import React from "react";
import { useSelector } from "react-redux";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Navbar from "components/navbar";
import Sidebar from "components/sidebar";
import routes from "routes.js";
import { API_NAME } from "../../constants";
import { getActiveNavbar, getRoutes, getActiveRoute, filterRoutes } from "../../utils";

export default function Console(props) {
  const { ...rest } = props;
  const location = useLocation();
  const [open, setOpen] = React.useState(true);

  const user = useSelector((state) => state.auth.user);
  const modules = useSelector((state) => state.auth.modules);

  const allowedRoutes = React.useMemo(
		() => filterRoutes(routes, user?.user_level, modules),
		[user?.user_level, modules]
	);

  React.useEffect(() => {
    const handleResize = () => window.innerWidth < 1200 ? setOpen(false) : setOpen(true);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  
  React.useEffect(() => {
    getActiveRoute(routes, location.pathname, );
  }, [location.pathname, getActiveRoute]);
  
  document.documentElement.dir = "ltr";
  return (
    <div className="flex h-full w-full">
      <div className="page-bg-primary fixed h-screen w-screen"/>
      <Sidebar open={open} onClose={() => setOpen(false)} routes={allowedRoutes}/>
      <div className="h-full w-full bg-lightPrimary dark:!bg-intsamis-900">
        <main className={`mx-[12px] h-full flex-none transition-all md:pr-2 xl:ml-[313px]`}>
          <div className="h-full">
            <Navbar
              onOpenSidenav={() => setOpen(true)}
              logoText={"DA Kiosk"}
              secondary={getActiveNavbar(allowedRoutes)}
              allowedRoutes={allowedRoutes}
              {...rest}
            />
            <div className="pt-5s mx-auto mb-auto h-full min-h-[84vh] p-2 md:pr-2">
              <Routes>
                {getRoutes(allowedRoutes)}
                <Route path="/" element={<Navigate to="/console/dashboard" replace />}/>
              </Routes>
            </div>
            <div className="p-3">
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
